import { render, staticRenderFns } from "./customerGroup.vue?vue&type=template&id=253cea84&scoped=true"
import script from "./customerGroup.vue?vue&type=script&lang=js"
export * from "./customerGroup.vue?vue&type=script&lang=js"
import style0 from "./customerGroup.vue?vue&type=style&index=0&id=253cea84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253cea84",
  null
  
)

export default component.exports